export const useExploreFilter = () => {
  // Composable
  const { t } = useI18n();

  // Store
  const { areaId } = storeToRefs(exploreStore());

  const getEPIOptionList = (): { key: string; label: string }[] => {
    const area = areaStore().getArea(areaId.value);

    const options = [
      {
        key: 'quantity',
        label: `kWh / ${area?.production_unit?.symbol ?? '--'}`,
      },
      {
        key: 'cost',
        label: `€ / ${area?.production_unit?.symbol ?? '--'}`,
      },
      {
        key: 'co2',
        label: `gCO2 / ${area?.production_unit?.symbol ?? '--'}`,
      },
    ];

    return options;
  };

  // Computed
  const getEnergyTypes = computed(() => {
    const area = areaStore().getArea(areaId.value);
    const meters = meterStore().getMeters.reduce((acc, meter) => {
      acc[meter.meter_type.energy_type] = acc[meter.meter_type.energy_type] || [];
      acc[meter.meter_type.energy_type].push(meter);
      return acc;
    }, {});

    return Object.keys(meters).map((energyType) => ({
      label: t(`global.energy_type.${energyType}`),
      key: energyType,
      secondaryLabel: area?.meters.some((meter) => meter.meter_type.energy_type === energyType) ? '' : meters[energyType][0].area.name,
      areaToRedirect: area?.meters.some((meter) => meter.meter_type.energy_type === energyType) ? null : meters[energyType][0].area.id,
    }));
  });

  const getZoneOptionList = computed((): { label: string; key: number }[] => {
    return [
      { label: t('explore.one_level'), key: 1 },
      { label: t('explore.two_levels'), key: 2 },
      { label: t('explore.three_levels'), key: 3 },
    ];
  });

  return {
    getEPIOptionList,
    getEnergyTypes,
    getZoneOptionList,
  };
};
